import { Col, DatePicker, Form, Input, Select } from 'antd';
import dayjs from 'dayjs';
import { CustomFields, parseRules } from 'helpers/customFields';
import { EventAttendanceCustomFields } from 'interfaces/event';

type Props = {
  config: EventAttendanceCustomFields;
  customFields?: Partial<CustomFields>;
  customName?: string;
  inviteKey?: string;
};

const CustomFieldsForm = ({ config, customFields, customName }: Props): JSX.Element => {
  const { name, label, fullWidth, options } = config;
  const isRequired = config.rules.includes('required');

  if (!customFields || Object.keys(customFields).length === 0) {
    customFields = {};
  }

  switch (config.type) {
    case 'text':
      return (
        <Col xs={24} md={fullWidth ? 24 : 12}>
          <Form.Item
            name={customName ? customName : `custom_field.${name}`}
            label={label}
            id={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            key={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            required={isRequired}
            rules={[...parseRules(config.rules)]}
            initialValue={customFields[name]}
          >
            <Input id={`${name}-custom-input`} />
          </Form.Item>
        </Col>
      );

    case 'date':
      return (
        <Col xs={24} md={fullWidth ? 24 : 12}>
          <Form.Item
            name={customName ? customName : `custom_field.${name}`}
            label={label}
            id={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            key={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            rules={[...parseRules(config.rules)]}
            initialValue={!!customFields[name] ? dayjs(customFields[name]) : ''}
          >
            <DatePicker
              id={customName ? `${customName}_form_field` : `${name}-custom-input`}
              format={'DD/MM/YYYY'}
              placeholder='Selecione a data'
              maxDate={dayjs()}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      );

    case 'select':
      const initialValue = options.find(option => option.value == customFields[name])?.value;
      return (
        <Col xs={24} md={fullWidth ? 24 : 12}>
          <Form.Item
            name={customName ? customName : `custom_field.${name}`}
            label={label}
            id={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            key={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
            rules={[...parseRules(config.rules)]}
            initialValue={initialValue}
          >
            <Select
              id={customName ? `${customName}_form_field` : `${name}-custom-input`}
              placeholder='Selecione uma opção'
              key={customName ? `${customName}_form_field` : `${name}-custom-form-field`}
              style={{ width: '100%' }}
              options={options}
              showSearch
              optionFilterProp='label'
              notFoundContent='Nenhuma opção encontrada'
              allowClear
            />
          </Form.Item>
        </Col>
      );

    default:
      throw 'Unknown custom field type ' + config.type;
  }
};

export default CustomFieldsForm;
